import '../img/forest_01.jpg';

import '../img/snowwalk.svg';
import '../img/rakiety.svg';
import '../img/adjust.svg';
import '../img/map.svg';
import '../img/park.svg';
import '../img/share.svg';
import '../img/snowshoes.svg';

import '../img/flame.svg';
import '../img/milestone.svg';

import '../img/trail_blue.svg';
import '../img/trail_black.svg';
import '../img/trail_red.svg';
import '../img/trail_green.svg';
import '../img/trail_yellow.svg';
import '../img/trail_bic_blue.svg';
import '../img/trail_bic_green.svg';
import '../img/trail_bic_black.svg';
import '../img/trail_bic_yellow.svg';
import '../img/trail_bic_red.svg';

import '../img/travel_bus.svg';
import '../img/travel_car.svg';
import '../img/travel_park.svg';
import '../img/travel_reception.svg';
import '../img/travel_rest.svg';
import '../img/travel_shed.svg';
import '../img/travel_sos.svg';
import '../img/travel_trash.svg';
import '../img/travel_toilet.svg';

import '../img/ico_gpx_small.svg';
import '../img/start.svg';

import '../img/wi-fog.svg';
import '../img/wi-snow.svg';
import '../img/wi-stars.svg';
import '../img/wi-strong-wind.svg';

import '../img/Earth_logo_path.svg';
import '../img/esTEAM_logo_path.svg';
import '../img/w3box_logo_path.svg';

import '../img/cpstartico.png';
import '../img/start.png';
import '../img/ico_endomondo.png';
import '../img/ico_movescount.png';
import '../img/ico_runtastic.png';
import '../img/ico_strava.png';

import '../img/ico_gpx_small.gif';

import '../img/trail_blue.gif';
import '../img/trail_black.gif';
import '../img/trail_red.gif';
import '../img/trail_green.gif';
import '../img/trail_yellow.gif';
import '../img/trail_bic_blue.gif';
import '../img/trail_bic_green.gif';
import '../img/trail_bic_black.gif';
import '../img/trail_bic_yellow.gif';
import '../img/trail_bic_red.gif';

import '../img/travel_bus.gif';
import '../img/travel_car.gif';
import '../img/travel_park.gif';
import '../img/travel_reception.gif';
import '../img/travel_rest.gif';
import '../img/travel_shed.gif';
import '../img/travel_sos.gif';
import '../img/travel_trash.gif';

